import React, { useEffect, useState } from 'react';
import { Radio } from '@material-ui/core';
import { IKakarikoRadioProps } from './types';
import { StyledKakarikoRadio, StyledLabel, StyledLegend } from './styles';

export const KakarikoRadio = (props: IKakarikoRadioProps) => {
  const {
    className = '',
    disabled,
    disableRipple = true,
    errorMessage,
    hasError,
    handleChange,
    id,
    legend = '',
    name,
    options,
    value,
    styles = {},
    size,
  } = props;

  const [touched, setTouched] = useState(false);

  const handleBlurInternal = () => {
    setTouched(true);
  };

  useEffect(() => {
    if (value != null) {
      setTouched(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledKakarikoRadio className={`${className}`} style={{ ...styles }}>
      <div className={'radio-selections'}>
        {legend && <StyledLegend>{legend}</StyledLegend>}
        {options.map((option) => (
          <React.Fragment key={`${option}`}>
            <Radio
              color="default"
              className={'root'}
              checked={value === `${option}`}
              checkedIcon={<span className="icon checked-icon" />}
              disabled={disabled}
              disableRipple={disableRipple}
              icon={
                <span
                  className={`icon${hasError && touched ? ' error' : ''}`}
                />
              }
              id={id}
              name={name}
              onBlur={handleBlurInternal}
              onChange={(e) => handleChange?.(e.target.value)}
              size={size}
              value={option}
            />
            <StyledLabel
              className={`${hasError && touched ? ' error' : ''}`}
              htmlFor={`${option}`}
            >
              {`${option}`}
            </StyledLabel>
          </React.Fragment>
        ))}
      </div>
      {hasError && touched && errorMessage && (
        <div className="error">{errorMessage}</div>
      )}
    </StyledKakarikoRadio>
  );
};
